module.exports = __webpack_public_path__ + "img/probija_logo.73da5761.svg";